import { useState } from 'react';
import { useNavigate } from 'react-router';
import { usePermissions } from '@/hooks/use-permissions';
import { RULES_PATH } from '../components/managed-by-rules-notice';
import { PlaybookTemplates } from '../components/playbook-templates';
import type { PlaybookPlace } from '../lib/places';
import { useRulesEnabled } from './use-rules-enabled';

/** Only administrators build playbooks; everyone else can open and read them. */
export const useIsPlaybookAdmin = (): boolean => {
	const { role, isSuperAdmin } = usePermissions();
	return isSuperAdmin || role === 'administrator';
};

/** Opens the builder for a new custom playbook on this page, and the template gallery for it. */
export function useCreateCustomPlaybook(place: PlaybookPlace) {
	const navigate = useNavigate();
	const [galleryOpen, setGalleryOpen] = useState(false);
	const enabled = useRulesEnabled();
	const isAdmin = useIsPlaybookAdmin();
	const available = enabled && isAdmin;
	return {
		available,
		create: () => navigate(`${RULES_PATH}/new?place=${place}`),
		openGallery: () => setGalleryOpen(true),
		gallery: available ? <PlaybookTemplates open={galleryOpen} onOpenChange={setGalleryOpen} place={place} /> : null
	};
}
